import LocationChooser from "./LocationChooser";

export default LocationChooser;
